import { render, staticRenderFns } from "./CuponesAplComponent.vue?vue&type=template&id=ab75a0e4&scoped=true&"
import script from "./CuponesAplComponent.vue?vue&type=script&lang=js&"
export * from "./CuponesAplComponent.vue?vue&type=script&lang=js&"
import style0 from "./CuponesAplComponent.vue?vue&type=style&index=0&id=ab75a0e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab75a0e4",
  null
  
)

export default component.exports